import SiteTile from './SiteTile';
export type { SiteTileProps } from '../../types/sites.types';

export default SiteTile;
